import { Container, FlexBox } from "@components/wrapper"
import { SchoolTutor } from "@interfaces/school"
import clsx from "clsx"
import Image from "next/image"
import React from "react"
import Carousel from "react-multi-carousel"
import { BootcampSliderArrow } from "."
import { BootcampHeading } from "../general/ProgramHeading"

const TutorCard = ({ value }: { value: SchoolTutor }) => {
  return (
    <div className="bg-white rounded-10 card-box sm-only:w-[55vw]">
      <div className="sm:h-[19.5vw] h-[55vw]">
        <Image
          src={value.tutor_picture}
          alt={value.tutor_name}
          width={300}
          height={300}
          className="sm:h-[19.5vw] h-[55vw] object-cover rounded-t-10 w-full"
        />
      </div>
      <div className={clsx("bg-white relative rounded-b-10", "px-4 pb-4 pt-[22px]")}>
        <FlexBox
          justify="center"
          align="center"
          className={clsx(
            "bg-body-bg border rounded border-new-grey p-2 sm:wh-12 wh-10",
            "absolute sm:-top-7 -top-6 right-4"
          )}
        >
          <Image
            src={value.company.company_picture}
            width={48}
            height={48}
            alt={value.company.company_name}
            className="wh-auto"
          />
        </FlexBox>

        <div className="grid sm:gap-2 gap-1">
          <div className="font-urbanist font-bold sm-only:text-sm">{value.tutor_name}</div>
          <div className="sm:text-sm text-xs flex gap-2">
            <span>💼 </span>
            <span className="text-secondary-grey line-clamp-1" title={value.tutor_as}>
              {value.tutor_as}
            </span>
          </div>
          <div className="w-full h-[1px] bg-[rgba(58,53,65,0.12)]" />
          <div className="sm:text-sm text-xs  flex gap-2">
            <span>🏢 </span>
            <span className="text-secondary-grey line-clamp-1" title={value.company.company_name}>
              {value.company.company_name}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export const BootcampTutors = ({ tutors }: { tutors: SchoolTutor[] }) => {
  // Slider breakpoint
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  if(!tutors.length){
    return <></>
  }

  return (
    <div className="bg-[#CADCFF] sm:py-20 py-10">
      <Container>
        <div className="sm:mb-9 relative mb-6">
          <BootcampHeading
            id="tutors"
            title="tutor"
            subTitle="Belajar Bareng Tutor yang Ahli di Bidangnya"
          />
        </div>

        {/* Web */}
        <div className="sm-only:hidden grid gap-9">
          <Carousel
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            containerClass={clsx("sm:-ml-4.5")}
            itemClass="px-4.5"
            arrows={false}
            customButtonGroup={
              <BootcampSliderArrow
                length={tutors.length}
                displayedSlide={4}
                className="gap-6 justify-center"
              />
            }
            renderButtonGroupOutside
            className="d-lg-flex d-none"
          >
            {tutors.map((value) => (
              <TutorCard value={value} key={value.id} />
            ))}
          </Carousel>
        </div>

        {/* Mobile */}
        <div
          className={clsx("sm:hidden", "slider-mobile -mx-[18px] w-[calc(100%+32px)] px-[18px]")}
        >
          {" "}
          <div className={clsx("flex w-max gap-4")}>
            {tutors.map((value, i) => (
              <TutorCard value={value} key={i} />
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}
